export const LATEST = 'latest';

export const HARBOR_REPOSITORY_ANNOTATION = 'goharbor.io/repository-slug';
